import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { BaseResponseModel } from "@/models/core.model";

export const fetchAndStoreStravaActivities = async (userId: number, fetchOlderActivities: boolean, pageSize?: number)
  : Promise<BaseResponseModel<number>> => {
  return await getReq(createUrl(`a/ThirdParty/Strava/FetchAndStoreStravaActivities`),
  {params: {userId, fetchOlderActivities, pageSize}}
  ).then((res: any) => res.data);
};

export const processStravaActivities = async (userId: number): Promise<BaseResponseModel<boolean>> => {
  return await postReq(createUrl("a/ThirdParty/Strava/ProcessStravaActivities"),
    undefined, {params: {userId}}
  ).then((res: any) => res.data);
};